<template>
  <div class="story-page">
    <Header />
    <div class="story-wrap">
      <img :src="image" alt="これは日向坂46とあなたの恋の物語">
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';
import resolution from '@/mixin/resolution';
export default {
  name: 'StoryPage',
  components: {
    Header,
    Footer
  },
  mixins: [resolution],
  computed: {
    image() {
      return this.isPC ? require('@/assets/images/story/pc_img_story_01.png') : require('@/assets/images/story/sp_img_story_01.png');
    }
  }
}
</script>

<style lang="scss" scoped>
.story-page {
  height: calc(100vh - 70px);
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: space-between;
  .story-wrap {
    img {
      width: 100%;
    }
  }
}
@media screen and (max-width: 1023px) {
  .story-page {
    height: calc(100vh - 50px);
  }
}
</style>
